<template>
    <div class="card-slot" :style="{left: pos.x + 'px', top: pos.y + 'px'}">
        <card v-if="slug != null" :slug="slug"/>
        <div v-else class="card-slot__empty"></div>
    </div>
</template>

<script>
    import Card from './Card'

    export default {
        components: {Card},
        props: {
            slug: {default: () => null},
            pos: {type: Object}
        }
    }
</script>